import {Tooltip} from "rsuite";
import React from "react";

const textStyle = {
  fontSize: 14,
  lineHeight: 1,
}

const p1Style = {
  marginBottom: 5,
  paddingBottom: 0,
  marginTop: 10
}

export const filterAllTooltip = (
  <Tooltip>
    <p style={{...textStyle, ...p1Style}}>Click here to view All residents.</p>
  </Tooltip>
);
export const filterUrgentTooltip = (
  <Tooltip>
    <p style={{...textStyle, ...p1Style}}>Click here to view only Urgent residents.</p>
  </Tooltip>
);
export const filterWarningTooltip = (
  <Tooltip>
    <p style={{...textStyle, ...p1Style}}>Click here to view only residents with Warning alerts.</p>
  </Tooltip>
);
export const filterPaRTooltip = (
  <Tooltip>
    <p style={{...textStyle, ...p1Style}}>Click here to view only residents who have been designated as Patients at Risk on the Resident Configuration
      page.</p>
  </Tooltip>
);
export const sectionDataTooltip = (
  <Tooltip>
    <p style={{...textStyle, ...p1Style}}>Click here to view the summary data for the current location.</p>
  </Tooltip>
);